import React from "react";

/** [T2] Heal badge — pulses when healer ran recently */
export default function HealBadge({ healLog, onOpen }) {
  const recent = healLog && healLog.length > 0 && (Date.now() - healLog[healLog.length - 1].ts) < 8000;
  const count  = (healLog || []).length;
  if (!count) return null;

  return (
    <button
      onClick={onOpen}
      style={{
        display: "flex", alignItems: "center", gap: 5, padding: "3px 10px",
        background: recent ? "#1c0e00" : "transparent",
        border: recent ? "1px solid #fb923c50" : "1px solid transparent",
        borderRadius: 5, cursor: "pointer",
      }}
    >
      <span style={{ fontSize: 10, color: recent ? "#fb923c" : "#3d5068" }}>⚕</span>
      <span style={{ fontSize: 8,  color: recent ? "#fb923c" : "#3d5068" }}>
        {recent ? "Auto-corrected" : "Heal log"}
      </span>
    </button>
  );
}
